/* eslint-disable max-len */
import React, { memo } from 'react';
import Button from '@kmdpartners/ui-kit/src/CN_Design_System/components/Button';
import Accordion from '@kmdpartners/ui-kit/src/CN_Design_System/components/Accordion';
import { ICONS } from '@kmdpartners/ui-kit/src/CN_Design_System/constants/icons';
import makeIconName from '@kmdpartners/ui-kit/src/CN_Design_System/utils/makeIconName';
import styles from './index.module.scss';
const TABS = [
    {
        label: 'How much can I borrow?',
        description: 'Generally, unsecured loans are offered up to $5,000.  However, your resident state will affect both the minimum and maximum loan amounts offered, in addition to whether your loan will be directly made by CreditNinja or arranged by one of our FDIC-insured banks or other non-affiliated lenders.'
    },
    {
        label: 'How will my loan be funded?',
        description: 'Your funds will be deposited directly into your checking account via direct deposit.'
    },
    {
        label: 'What is an installment loan?',
        description: 'An installment loan is a loan where you borrow a lump sum of money up front and pay it back in fixed amounts over a set period of time. The installment loans are fully amortizing, meaning that you will pay off all principal and interest by the maturity date if you pay the loan as scheduled according to your loan agreement.'
    },
    {
        label: 'How quickly can I get a loan?',
        description: 'Applications approved before 10:30 a.m. CT Monday – Friday are generally funded the same business day. Applications approved after this time are generally funded the next business day. Some applications may require additional verification, in which case the loan, if approved, will be funded the business day after such additional verification is completed.'
    },
    {
        label: 'What can you use CreditNinja loans for?',
        description: 'CreditNinja loans are ideal for unexpected financial emergencies. Many CreditNinja customers use our installment loans for a wide range of expenses including: medical bills, home and appliance repairs, overdue bills or rent, and auto repairs, to name a few.'
    },
    {
        label: 'What makes CreditNinja loans different?',
        description: 'CreditNinja stands out by offering a safe alternative for borrowers who are struggling financially. Apply online in minutes, get a decision, and if approved, your funds will be directly deposited into your bank account. Plus, our friendly and helpful customer service team is here to assist you every step of the way.'
    }
];
const Questions = memo(() => {
    return (React.createElement("section", { id: 'home_questions', className: styles.questionsWrap },
        React.createElement("div", { className: styles.questionsContainer },
            React.createElement("i", { className: makeIconName(ICONS.x64.five, 'x64') }),
            React.createElement("h2", { className: styles.title },
                React.createElement("strong", null, "Frequently Asked Questions")),
            React.createElement("div", { className: styles.accordionWrap },
                React.createElement(Accordion, { isFullWidth: true, itemsList: TABS })),
            React.createElement(Button, { ID: 'apply_now_button__questions', btnSize: 'L', isFullWidth: true, type: 'primaryBlue', isBold: true, label: 'Apply Now', href: '/registration?utm_source=dojo' }))));
});
Questions.displayName = 'Questions';
export default Questions;
